<template>
    <template v-for="item in items" :key="item.id">
        <a
            :href="item.product_url"
            class="product-card text-small"
            :data-video="item.video?.url || null">

            <div class="product-card__thumbnail">
                <img
                    v-if="item.thumbnail?.thumbnail"
                    :src="item.thumbnail.medium"
                    data-root-margin="0px 0px 271px 0px"
                    :alt="item.product_title"
                />
                <span v-if="item.video" class="play-icon">
                    <i class="icon-play"></i>
                </span>
            </div>
            <div class="product-card__header">
                <div class="product-card__title">{{ item.product_title }}</div>
                <div v-if="item.evaluation_count > 0" class="product-card__rate">
                    <i class="icon-star"></i> {{ getRate(item) }}
                </div>
            </div>
            <div class="product-card__prices">
                <span class="product-card__sale_price">
                    {{ NumberFormat.format( item.sale_price / 100 ) }}
                </span>
                <span
                    v-if="1 === 0 && item.price !== item.sale_price"
                    class="product-card__price"
                    style="display:none"
                >
                    {{ NumberFormat.format( item.price / 100 ) }}
                </span>
            </div>
        </a>
    </template>
    <!-- Sentinel-элемент для IntersectionObserver -->
    <div ref="sentinel" style="height: 1px;"></div>
    <div v-if="loading" class="products__loader"></div>
</template>

<script>

import {defineComponent} from 'vue'

export default defineComponent({
    name: 'ProductsApp',
    data() {
        return {
            loading: false,
            stats: window.stats || {},
            items: [],
            total: 0,
            page: 1, // 1-я страница уже отрисована Phalcon
            pageSize: 0,

            observer: null,
            NumberFormat: {},
        }
    },
    computed: {
        allLoaded() {
            return this.total > 0 && (this.pageSize + this.items.length) >= this.total;
        }
    },
    created() {
        this.NumberFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: this.stats.currency || 'USD'});
    },
    mounted() {

        const el = document.getElementById('products-app');
        if( el ) {
            this.total = parseInt(el.dataset.total) || 0;
            this.pageSize = parseInt(el.dataset.pageSize) || 0;
            this.initObserver()
        }
    },
    beforeUnmount() {
        this.observer?.disconnect()
    },
    methods: {
        initObserver() {
            this.observer = new IntersectionObserver(([entry]) => {
                if( entry.isIntersecting && ! this.loading ) {
                    this.loadMore()
                }
            }, { rootMargin: '0px 0px 400px 0px' })

            this.observer.observe( this.$refs.sentinel )
        },
        async loadMore() {

            if( this.loading || this.allLoaded )
                return;

            this.loading = true

            try {
                const response = await this.$http.post('/product/list', {
                    page: this.page + 1,
                    page_size: this.pageSize,
                })
                const data = response.data.data;

                if( data?.items?.length > 0 ) {
                    this.items.push(...data.items);
                    this.page++;
                }
            } catch (err) {
                console.error('Error loading:', err);
            } finally {
                this.loading = false
            }
        },
        getRate( item ) {
            return item.evaluation_rate > 5
                ? item.evaluation_rate / 10
                : item.evaluation_rate
        },
    },
})
</script>